import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

type BadgeVariant = 'danger' | 'info' | 'neutral' | 'success' | 'warning'

const badgeClassName: Record<BadgeVariant, string> = {
  danger: 'bg-[#fff1f0] text-[#b42318]',
  info: 'bg-[rgba(25,91,255,0.1)] text-[var(--color-primary)]',
  neutral: 'bg-[var(--color-hover-muted)] text-[rgba(26,28,25,0.72)]',
  success: 'bg-[#f0faf3] text-[#16823c]',
  warning: 'bg-[#fff7e6] text-[#b76a00]',
}

export interface BadgeProps {
  children: ReactNode
  className?: string
  variant?: BadgeVariant
}

export function Badge({ children, className, variant = 'neutral' }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex h-6 items-center rounded-full px-2 text-xs font-medium leading-none whitespace-nowrap',
        badgeClassName[variant],
        className,
      )}
    >
      {children}
    </span>
  )
}
